import { PlaceholderPage } from './PlaceholderPage';

export const PayrollNotesPage = () => <PlaceholderPage title="Payroll Notes" subtitle={'Renamed from "Significant Date Types"'} />;
